{
    "(save {highestYearlyDiscount}%)": "(жылдық {highestYearlyDiscount}% үнемдеңіз)",
    "{amount} days free": "{amount} күн тегін",
    "{amount} off": "{amount} жеңілдік",
    "{amount} off for first {number} months.": "алғашқы {number} айға {amount} жеңілдік.",
    "{amount} off for first {period}.": "алғашқы {period} мерзімге {amount} жеңілдік.",
    "{amount} off forever.": "{amount} мәңгі жеңілдік.",
    "{buyerName} has gifted you a {duration}-month {tierName} membership to {siteTitle}_one": "",
    "{buyerName} has gifted you a {duration}-month {tierName} membership to {siteTitle}_other": "",
    "{buyerName} has gifted you a {duration}-year {tierName} membership to {siteTitle}": "",
    "{discount}% discount": "{discount}% жеңілдік",
    "{duration} membership": "",
    "{memberEmail} will no longer receive {newsletterName} newsletter.": "{memberEmail} енді {newsletterName} ақпараттық бюллетенін алмайды.",
    "{memberEmail} will no longer receive emails when someone replies to your comments.": "Пікірлеріңізге жауап берген кезде {memberEmail} хаттар алмайды.",
    "{memberEmail} will no longer receive this newsletter.": "{memberEmail} енді бұл ақпараттық бюллетенді алмайды.",
    "{memberEmail} will no longer receive updates & announcements.": "",
    "{months} month": "",
    "{months} months": "",
    "{months} months free": "",
    "{tierName} membership": "",
    "{trialDays} days free": "{trialDays} күн тегін",
    "{years} years": "",
    "+1 (123) 456-7890": "",
    "1 month": "",
    "1 month free": "",
    "1 year": "",
    "A gift, just for you": "",
    "Access your RSS feeds": "",
    "Account": "Аккаунт",
    "Account details updated successfully": "",
    "Account settings": "Аккаунт баптаулары",
    "Add a personal note": "",
    "Add a short note to go with your gift": "",
    "After a free trial ends, you will be charged the regular price for the tier you've chosen. You can always cancel before then.": "Тегін сынақ мерзімі аяқталғаннан кейін таңдаған деңгейіңіз үшін қалыпты баға төленеді. Оған дейін әрқашан бас тартуға болады.",
    "Already a member?": "Аккаунт бар ма?",
    "An error occurred": "",
    "An unexpected error occured. Please try again or <a>contact support</a> if the error persists.": "Күтпеген қате пайда болды. Қайта көріңіз немесе қате жалғаса берсе <a>қолдауға хабарласыңыз</a>.",
    "Back": "Қайту",
    "Back to Log in": "Кіру бетіне қайту",
    "Before you go": "",
    "Billing info & receipts": "",
    "Black Friday": "Қара Жұма",
    "Bluesky": "",
    "Cancel anytime.": "Кез келген уақытта бас тартуға болады.",
    "Cancel subscription": "Жазылымнан бас тарту",
    "Canceled": "",
    "Cancellation reason": "Бас тарту себебі",
    "Change": "Өзгерту",
    "Change plan": "",
    "Check spam & promotions folders": "Спам және жарнамалар қалталарын тексеріңіз",
    "Check with your mail provider": "Пошта провайдері арқылы тексеріңіз",
    "Check your inbox to verify email update": "",
    "Choose": "Таңдау",
    "Choose a date from today onwards": "",
    "Choose a date within the next year": "",
    "Choose a delivery date": "",
    "Choose a different plan": "Басқа жоспарды таңдау",
    "Choose a plan": "",
    "Choose a tier": "",
    "Choose your newsletters": "Ақпараттық бюллетеньдерді таңдау",
    "Click here to retry": "Қайта көру үшін мұнда басыңыз",
    "Click the confirmation link in your inbox to finish redeeming your membership. If it doesn't arrive within 3 minutes, check your spam folder.": "",
    "Close": "Жабу",
    "Code": "",
    "Comment preferences updated.": "",
    "Comments": "Пікірлер",
    "Complimentary": "Ақысыз",
    "Confirm": "Растау",
    "Confirm cancellation": "Бас тартуды растау",
    "Confirm subscription": "Жазылымды растау",
    "Contact support": "Қолдау бөліміне хабарласу",
    "Continue": "Жалғастыру",
    "Continue subscription": "Жазылымды жалғастыру",
    "Continue to delivery details": "",
    "Continue to payment": "",
    "Continue with a paid subscription anytime. Your remaining gift period will be added as a free trial.": "",
    "Copied": "",
    "Copy": "",
    "Copy link": "",
    "Could not create Stripe billing portal session": "",
    "Could not create Stripe checkout session": "",
    "Could not sign in. Login link expired.": "Кіру мүмкін болмады. Кіру сілтемесінің мерзімі өтіп кетті.",
    "Could not update email! Invalid link.": "Email поштаны жаңарту мүмкін болмады! Жарамсыз сілтеме.",
    "Create a new contact": "Жаңа контакт құру",
    "Current plan": "Ағымдағы жоспар",
    "Delete account": "Аккаунтты жою",
    "Delivery date": "",
    "Delivery method": "",
    "Didn't mean to do this? Manage your preferences <button>here</button>.": "Мұны жасағыңыз келмеді ме? Теңшелімдерді <button>осында</button> басқарыңыз.",
    "Don't have an account?": "Аккаунтыңыз жоқ па?",
    "Edit": "Өңдеу",
    "Email": "Email",
    "Email confirmation link expired.": "",
    "Email it to them": "",
    "Email newsletter": "Email бюллетені",
    "Email newsletter settings updated": "",
    "Email preferences": "Email теңшелімдері",
    "Email preferences updated.": "",
    "Emails": "Электрондық хаттар",
    "Emails disabled": "Электрондық хаттар өшірілген",
    "Ends {offerEndDate}": "{offerEndDate} аяқталады",
    "Enjoy {amountOff} off forever.": "",
    "Enjoy {months} free months on us.": "",
    "Enjoy {months} free months on us. You won't be charged until {newBillingDate}.": "",
    "Enjoy a free month on us.": "",
    "Enjoy a free month on us. You won't be charged until {newBillingDate}.": "",
    "Enter code above": "",
    "Enter the recipient's email address": "",
    "Enter your email address": "",
    "Enter your name": "",
    "Error": "Қате",
    "Expires {expiryDate}": "{expiryDate} аяқталады",
    "Facebook": "",
    "Failed to cancel subscription, please try again": "",
    "Failed to log in, please try again": "",
    "Failed to log out, please try again": "",
    "Failed to open billing portal, please try again": "",
    "Failed to process checkout, please try again": "",
    "Failed to send magic link email": "",
    "Failed to send verification email": "",
    "Failed to sign up, please try again": "",
    "Failed to update account data": "",
    "Failed to update account details": "",
    "Failed to update billing information, please try again": "",
    "Failed to update newsletter settings": "",
    "Failed to update subscription, please try again": "",
    "Failed to verify code, please try again": "",
    "Forever": "Үздіксіз",
    "Free Trial – Ends {trialEnd}": "Тегін сынақ мерзімі – {trialEnd} аяқталады",
    "From": "",
    "Get help": "Көмек алу",
    "Get in touch for help": "Көмек алу үшін байланысу",
    "Get notified when someone replies to your comment": "Біреу пікіріңізге жауап берген кезде хабарландыру алу",
    "Gift a membership": "",
    "Gift could not be redeemed": "",
    "Gift details": "",
    "Gift duration": "",
    "Gift link copied to clipboard": "",
    "Gift redeemed! You're all set.": "",
    "Gift subscription": "",
    "Gift subscriptions are not available right now.": "",
    "Gift value": "",
    "Give feedback on this post": "Осы жазбаға кері байланыс беру",
    "Help! I'm not receiving emails": "Көмек! Маған электрондық хаттар келмеді",
    "Here are a few other sites you may enjoy.": "Сізге ұнауы мүмкін басқа да сайттар.",
    "Hi {recipientName},": "",
    "Hide details": "",
    "How would you like to share this gift?": "",
    "I'll share it myself": "",
    "If a newsletter is flagged as spam, emails are automatically disabled for that address to make sure you no longer receive any unwanted messages.": "Егер ақпараттық бюллетень спам ретінде белгіленсе, қажетсіз хабарламаларды енді алмас үшін электрондық хаттар автоматты түрде сол мекенжай үшін өшіріледі.",
    "If the spam complaint was accidental, or you would like to begin receiving emails again, you can resubscribe to emails by clicking the button on the previous screen.": "Егер спам шағымы кездейсоқ болса немесе сіз қайтадан электрондық хаттарды алғыңыз келсе, алдыңғы экрандағы түймені басып, қайта жазылуға болады.",
    "If you cancel your subscription now, you will continue to have access until {periodEnd}.": "Егер жазылымнан қазір бас тартсаңыз, қолжетімділік {periodEnd} мерзіміне дейін сақталады.",
    "If you have a corporate or government email account, reach out to your IT department and ask them to allow emails to be received from {senderEmail}": "Егер сізде корпоративтік немесе үкіметтік электрондық пошта аккаунты болса, IT бөліміне хабарласып, {senderEmail} мекенжайынан хаттарды қабылдауға рұқсат беруін сұраңыз.",
    "If you have an account, a login link has been sent to your inbox. If it doesn't arrive in 3 minutes, be sure to check your spam folder.": "Кіру сілтемесі кіріс жәшігіңізге жіберілді. Егер ол 3 минут ішінде келмесе, спам қалтасын тексеріңіз.",
    "If you have an account, an email has been sent to {submittedEmailOrInbox}. Click the link inside or enter your code below.": "",
    "If you would like to start receiving emails again, the best next steps are to check your email address on file for any issues and then click resubscribe on the previous screen.": "Егер қайтадан электрондық хаттарды алғыңыз келсе, ең абзалы электрондық пошта мекенжайыңызда бәрі дұрыстығын тексеру және алдыңғы экрандағы қайта жазылу түймесін басу.",
    "If you're not receiving the email newsletter you've subscribed to, here are a few things to check.": "Егер сіз жазылған электрондық бюллетень келмей жатса, тексеру керек бірнеше нәрсе бар.",
    "If you've completed all these checks and you're still not receiving emails, you can reach out to get support by contacting {supportAddress}.": "Егер тексеру керек барлық нәрсені жасап, хаттар әлі де келмесе, {supportAddress} мекенжайына хабарласып, көмекке жүгініңіз.",
    "In the event a permanent failure is received when attempting to send a newsletter, emails will be disabled on the account.": "Ақпараттық бюллетеньді жіберу сәтінде тұрақты қате шықса, аккаунттағы хаттар өшіріледі.",
    "In your email client add {senderEmail} to your contacts list. This signals to your mail provider that emails sent from this address should be trusted.": "Электрондық пошта клиентінде {senderEmail} адресін контактілер тізіміне қосыңыз. Бұл провайдерге осы адрестен жіберілген хаттардың сенімді екенін көрсетеді.",
    "Invalid email address": "",
    "Invalid verification code": "",
    "Jamie Larson": "",
    "jamie@example.com": "",
    "Less like this": "Мұндайдан азырақ",
    "LinkedIn": "",
    "Make sure emails aren't accidentally ending up in the Spam or Promotions folders of your inbox. If they are, click on \"Mark as not spam\" and/or \"Move to inbox\".": "Хаттардың кездейсоқ Спам немесе Жарнамалар қалтасына түсіп кетпеуін қадағалаңыз. Егер олар сол жерге түссе, \"Спам емес\" және/немесе \"Кіріс жәшігіне көшіру\" түймесін басыңыз.",
    "Manage": "Басқару",
    "Maybe later": "Мүмкін кейінірек",
    "Membership details": "",
    "Memberships from this email domain are currently restricted.": "",
    "Memberships unavailable, contact the owner for access.": "Аккаунт қосу мүмкін емес, қолжетімділік үшін иесіне хабарласыңыз.",
    "month": "",
    "Monthly": "Ай сайын",
    "More like this": "Мұндайдан көбірек",
    "More options": "",
    "Name": "Есімі",
    "Need more help? Contact support": "Қосымша көмек керек пе? Қолдау бөліміне хабарласыңыз",
    "Newsletters can be disabled on your account for two reasons: A previous email was marked as spam, or attempting to send an email resulted in a permanent failure (bounce).": "Ақпараттық бюллетеньдер аккаунтыңызда екі себеп бойынша өшірілуі мүмкін: Алдыңғы хат спам ретінде белгіленген немесе хат жіберу әрекеті тұрақты қате (қайту) шыққан.",
    "No member exists with this e-mail address.": "",
    "No thanks, I want to cancel": "",
    "Not ready to share? We've also emailed a copy to your inbox.": "",
    "Not receiving emails?": "Хаттар келмей жатыр ма?",
    "Now": "",
    "Now check your email!": "Енді электрондық поштаңызды тексеріңіз!",
    "Occasional updates from {siteTitle}": "",
    "Once resubscribed, if you still don't see emails in your inbox, check your spam folder. Some inbox providers keep a record of previous spam complaints and will continue to flag emails. If this happens, mark the latest newsletter as 'Not spam' to move it back to your primary inbox.": "Қайта жазылғаннан кейін, егер әлі де кіріс жәшігіңізде хаттар көрінбесе, спам қалтасын тексеріңіз. Кейбір пошта провадерлері бұрынғы спам шағымдарын сақтап, хаттарды белгілеуін жалғастырады. Егер солай болса, соңғы ақпараттық бюллетеньді \"Спам емес\" деп белгілеңіз және оны негізгі кіріс жәшігіне жылжытыңыз.",
    "Open AOL Mail": "",
    "Open email": "",
    "Open Feedbin": "",
    "Open Gmail": "",
    "Open Hey": "",
    "Open iCloud Mail": "",
    "Open Mail.ru": "",
    "Open Outlook": "",
    "Open Proton Mail": "",
    "Open Yahoo Mail": "",
    "Optional message": "",
    "Permanent failure (bounce)": "Тұрақты қате (қайту)",
    "Phone number": "",
    "Plan": "Жоспар",
    "Plan checkout was cancelled.": "Жоспарды сатып алу тоқтатылды.",
    "Plan upgrade was cancelled.": "Жоспарды жаңарту тоқтатылды.",
    "Please contact {supportAddress} to adjust your complimentary subscription.": "Ақысыз жазылымды реттеу үшін {supportAddress} мекенжайына хабарласыңыз.",
    "Please enter {fieldName}": "",
    "Please fill in required fields": "Қажет жерлерді толтырыңыз",
    "Podcasts": "",
    "Re-enable emails": "Электрондық хаттарды қайта қосу",
    "Recipient's email": "",
    "Recipient's name": "",
    "Recommendations": "Ұсыныстар",
    "Redeem your gift": "",
    "Redeem your membership": "",
    "Redeeming...": "",
    "Renews at {price}.": "{price} бағасымен жаңартылады.",
    "Resume subscription": "",
    "Retry": "Қайта көру",
    "Save": "Сақтау",
    "Save {amountOff} on your next {durationInMonths} billing cycles. Then {currency}{originalPrice}/{cadence}.": "",
    "Save {amountOff} on your next billing cycle. Then {currency}{originalPrice}/{cadence}.": "",
    "Send the link below to share it with whoever you'd like.": "",
    "Sending login link...": "Кіру сілтемесі жіберілуде...",
    "Sending...": "Жіберілуде...",
    "Share": "",
    "Share a full membership to {siteTitle} with a friend or colleague": "",
    "Share it yourself": "",
    "Show all": "Барлығын көрсету",
    "Sign in": "Кіру",
    "Sign out": "Шығу",
    "Sign up": "Тіркелу",
    "Signup error: Invalid link": "Тіркелу қатесі: Жарамсыз сілтеме",
    "Signups from this email domain are currently restricted.": "",
    "Something went wrong, please try again later.": "",
    "Sorry, no paid plans are available.": "",
    "Sorry, no recommendations are available right now.": "",
    "Sorry, that didn’t work.": "Өкінішті, бұдан ештеңе шықпады.",
    "Spam complaints": "Спам шағымдары",
    "Start {amount}-day free trial": "{amount} күндік тегін сынақты бастау",
    "Starting {startDate}": "{startDate} бастап",
    "Starting today": "Бүгіннен бастап",
    "Submit feedback": "Кері байланыс жіберу",
    "Subscribe": "Жазылу",
    "Subscribed": "Жазылған",
    "Subscription plan updated successfully": "",
    "Success": "Тамаша",
    "Success! Check your email for magic link to sign-in.": "Тамаша! Кіруге арналған ғажайып сілтемені электрондық поштаңыздан қараңыз.",
    "Success! Your account is fully activated, you now have access to all content.": "Тамаша! Аккаунтыңыз толық іске қосылды, енді сізге барлық мазмұн қолжетімді.",
    "Success! Your email is updated.": "Тамаша! Электрондық поштаңыз жаңартылды.",
    "Successfully unsubscribed": "Жазылымнан бас тарту сәтті орындалды",
    "Taylor Reid": "",
    "taylor@example.com": "",
    "Thank you for subscribing. Before you start reading, below are a few other sites you may enjoy.": "Жазылғаныңызға рахмет. Оқуды бастамас бұрын, төменде сізге ұнауы мүмкін басқа да сайттар бар.",
    "Thank you for your support": "",
    "Thank you for your support!": "",
    "Thanks for the feedback!": "Кері байланыс үшін рахмет!",
    "That didn't go to plan": "Бірнәрсе қате болды",
    "The email address we have for you is {memberEmail} — if that's not correct, you can update it in your <button>account settings area</button>.": "Сіздің электрондық пошта мекенжайыңыз — {memberEmail} — егер бұл қате болса, оны <button>аккаунт баптауларынан</button> жаңарта аласыз.",
    "There was a problem submitting your feedback. Please try again a little later.": "Кері байланысты жіберу кезінде олқылық пайда болды. Кейінірек қайта көріңіз.",
    "There was an error cancelling your subscription, please try again.": "",
    "There was an error continuing your subscription, please try again.": "",
    "There was an error processing your payment. Please try again.": "",
    "There was an error sending the email, please try again": "",
    "This gift can only be redeemed once and expires on {expiryDate}.": "",
    "This gift has already been consumed.": "",
    "This gift has already been redeemed.": "",
    "This gift has been refunded.": "",
    "This gift has expired.": "",
    "This gift link is invalid.": "",
    "This site is invite-only, contact the owner for access.": "Бұл сайтқа тек шақырту бойынша кіруге болады, рұқсат алу үшін иесіне хабарласыңыз.",
    "This site is not accepting donations at the moment.": "",
    "This site is not accepting payments at the moment.": "",
    "This site only accepts paid members.": "",
    "Threads": "",
    "Tier": "",
    "To": "",
    "To complete signup, click the confirmation link in your inbox. If it doesn't arrive within 3 minutes, check your spam folder!": "іркелуді аяқтау үшін, кіріс жәшігіңіздегі растау сілтемесін басыңыз. Егер ол 3 минут ішінде келмесе, спам қалтасын тексеріңіз!",
    "To continue to stay up to date, subscribe to {publication} below.": "",
    "Too many attempts try again in {number} days.": "",
    "Too many attempts try again in {number} hours.": "",
    "Too many attempts try again in {number} minutes.": "",
    "Too many different sign-in attempts, try again in {number} days": "",
    "Too many different sign-in attempts, try again in {number} hours": "",
    "Too many different sign-in attempts, try again in {number} minutes": "",
    "Too many sign-up attempts, try again later": "",
    "Try free for {amount} days, then {originalPrice}.": "{amount} күн тегін қолданып көріңіз, содан кейінгі бағасы {originalPrice}.",
    "Unable to initiate checkout session": "",
    "Unlock access to all newsletters by becoming a paid subscriber.": "Ақылы түрде жазылу арқылы барлық ақпараттық бюллетеньдерге қол жеткізіңіз.",
    "Unsubscribe from all emails": "Барлық хаттарға жазылымнан бас тарту",
    "Unsubscribed": "Жазылымнан бас тартылды",
    "Unsubscribed from all emails.": "Барлық хаттарға жазылымынан бас тартылды",
    "Unsubscribing from emails will not cancel your paid subscription to {title}": "Хаттарға жазылымнан бас тарту {title} үшін төленген жазылымыңызды жоймайды",
    "Update": "Жаңарту",
    "Update your preferences": "Таңдауларыңызды жаңарту",
    "Updates & announcements": "",
    "Verification link sent, check your inbox": "Растау сілтемесі жіберілді, кіріс жәшігіңізді тексеріңіз",
    "Verify your email address is correct": "Email адресінің дұрыстығын тексеріңіз",
    "Verifying...": "",
    "View plans": "Жоспарларды көру",
    "We couldn't unsubscribe you as the email address was not found. Please contact the site owner.": "Біз сізді жазылымнан айыра алмадық, өйткені электрондық пошта мекенжайы табылмады. Сайт иесіне хабарласыңыз.",
    "We'd hate to see you leave. How about a special offer to stay?": "",
    "We'll email it to the recipient on {deliveryDate}. A copy is in your inbox too.": "",
    "We'll email it to the recipient. A copy will be in your inbox too.": "",
    "Welcome back, {name}!": "Қош келдіңіз, {name}!",
    "Welcome back!": "Қош келдіңіз!",
    "Welcome to {siteTitle}": "{siteTitle} сайтына қош келдіңіз",
    "What's included": "",
    "When an inbox fails to accept an email it is commonly called a bounce. In many cases, this can be temporary. However, in some cases, a bounced email can be returned as a permanent failure when an email address is invalid or non-existent.": "Кіріс жәшігі хатты қабылдай алмаса, бұл әдетте \"қайту\" деп аталады. Көп жағдайда бұл уақытша нәрсе. Алайда электрондық пошта мекенжайы жарамсыз я жоқ болған жағдайда қайтқан хат тұрақты қате ретінде танылуы мүмкін.",
    "Why has my email been disabled?": "Менің электрондық поштам неге өшірілді?",
    "X (Twitter)": "",
    "year": "",
    "Yearly": "Жыл сайын",
    "You already have an active subscription.": "",
    "You currently have a free membership, upgrade to a paid subscription for full access.": "Сізде әзірге тегін аккаунт бар, оның мүмкіндіктерін толық пайдалана алу үшін ақылы жазылымға жаңартыңыз.",
    "You have been successfully resubscribed": "Қайта жазылу сәтті орындалды",
    "You now have access to {tierName} until {expiryDate}. Enjoy!": "",
    "You're currently not receiving emails": "Сізге әзірге электрондық хаттар келіп жатқан жоқ",
    "You're not receiving emails": "Сізге электрондық хаттар келіп жатқан жоқ",
    "You're not receiving emails because you either marked a recent message as spam, or because messages could not be delivered to your provided email address.": "Сізге электрондық хаттар келіп жатқан жоқ, себебі жақында келген хат спам ретінде белгіленген немесе хабарламаларды сіз көрсеткен электрондық пошта мекенжайына жеткізу мүмкін емес.",
    "You've been gifted a {duration}-month {tierName} membership_one": "",
    "You've been gifted a {duration}-month {tierName} membership_other": "",
    "You've been gifted a {duration}-month {tierName} membership to {siteTitle}_one": "",
    "You've been gifted a {duration}-month {tierName} membership to {siteTitle}_other": "",
    "You've been gifted a {duration}-year {tierName} membership": "",
    "You've been gifted a {duration}-year {tierName} membership to {siteTitle}": "",
    "You've been gifted a membership": "",
    "You've been gifted a membership to {siteTitle}": "",
    "You've successfully signed in.": "Кіру сәтті орындалды.",
    "You've successfully subscribed to <strong>{siteTitle}</strong>": "Жазылым сәтті орындалды <strong>{siteTitle}</strong>",
    "Your account": "Сіздің аккаунт",
    "Your email": "",
    "Your email has failed to resubscribe, please try again": "",
    "Your gift is on its way": "",
    "Your gift is ready": "",
    "Your gift is scheduled": "",
    "Your gift subscription will expire on {expiryDate}": "",
    "your inbox": "",
    "Your input helps shape what gets published.": "Сіздің пікіріңіз жарияланатын мазмұнды қалыптастыруға көмектеседі.",
    "Your name": "",
    "Your subscription has been canceled and will expire on {expiryDate}.": "",
    "Your subscription will expire on {expiryDate}": "Сіздің жазылым {expiryDate} күні аяқталады",
    "Your subscription will renew on {renewalDate}": "Сіздің жазылым {renewalDate} күні қайта жаңартылады",
    "Your subscription will start on {subscriptionStart}": "Сіздің жазылым {subscriptionStart} күні басталады"
}
